import { Field, TextOutput } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { ListDropdown } from 'Components/List';
import { actions } from 'Data/ReduxViewModels/InterLab';
import { hasValue } from 'Lib/Any';
import { isNil } from 'ramda';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IInterLabSharedComponentProps } from '../types';
import { InterLabActionComponent } from './ActionComponent';

interface IInterLabWorkOrderSectionProps extends IInterLabSharedComponentProps {
  workOrderUUID: string | undefined;
}

const InterLabWorkOrderSection: React.FC<IInterLabWorkOrderSectionProps> = ({
  workOrderUUID,
  actionOption,
  onActionOptionChange,
}) => {
  const dispatch = useDispatch();

  const clientName = useSelector((state) => state.interLab.workOrder?.clientName);
  const projectName = useSelector((state) => state.interLab.workOrder?.projectName);
  const workOrderId = useSelector((state) => state.interLab.workOrder?.workOrderId);
  const fetchedWorkOrderUuid = useSelector((state) => state.interLab.workOrder?.id);

  useEffect(() => {
    if (workOrderUUID) {
      dispatch(actions.getWorkOrder(workOrderUUID));
    }
  }, [dispatch, workOrderUUID]);

  const handleWorkOrderChange = ({ data: { value } }: any) => {
    if (isNil(value)) {
      dispatch(actions.clearWorkOrder());
    } else {
      dispatch(actions.getWorkOrder(value.value));
    }
  };

  return (
    <>
      <ListFieldSection visible={hasValue(workOrderUUID) && hasValue(workOrderId)}>
        <Field input={<TextOutput />} label="Work Order" value={workOrderId} />
        <InterLabActionComponent actionOption={actionOption} onActionOptionChange={onActionOptionChange} />
      </ListFieldSection>
      <ListFieldSection visible={!hasValue(workOrderUUID)}>
        <Field
          input={<ListDropdown />}
          label="Work Order"
          endpoint="interlab.workorders"
          queryParams={{ orderBy: 'WorkDate desc' }}
          searchImmediately={true}
          maxResults={20}
          defaultValue={fetchedWorkOrderUuid ? { value: fetchedWorkOrderUuid, label: workOrderId } : null}
          placeholder="Select or enter Work Order ID to search"
          onChange={handleWorkOrderChange}
        />
        <InterLabActionComponent actionOption={actionOption} onActionOptionChange={onActionOptionChange} />
      </ListFieldSection>
      <ListFieldSection>
        <Field input={<TextOutput />} label="Client" value={clientName} />
        <Field input={<TextOutput />} label="Project" value={projectName} />
      </ListFieldSection>
    </>
  );
};

export { InterLabWorkOrderSection };
